export default {"src":"/_next/static/media/4.31d4a018.svg","height":84,"width":84,"blurWidth":0,"blurHeight":0};